/**
 * @file loading-spinner.js
 * @description Componente spinner de loading (CRA)
 */

import React from "react"
import { cn } from "../../../../lib/utils.js"
import { Loader2 } from "lucide-react"

const sizeClasses = {
  sm: "h-4 w-4",
  md: "h-6 w-6",
  lg: "h-8 w-8",
}

/**
 * Componente spinner de loading
 * @param {Object} props - Propriedades do componente
 * @param {'sm'|'md'|'lg'} props.size - Tamanho do spinner
 * @param {string} props.className - Classe CSS adicional
 * @param {string} props.message - Mensagem de carregamento
 * @returns {React.ReactElement} Spinner de loading
 */
export function LoadingSpinner({
  size = "md",
  className,
  message,
}) {
  return React.createElement(
    "div",
    { className: cn("flex flex-col items-center gap-2", className) },
    React.createElement(Loader2, {
      className: cn("animate-spin text-blue-500", sizeClasses[size]),
    }),
    message &&
      React.createElement(
        "p",
        { className: "text-sm text-gray-600 text-center" },
        message
      )
  )
}
